import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import cls from 'classnames/bind';
import s from './ServiceClasses.scss';

import NOOP from 'lodash/noop';
import { l10n } from '@ott/l10n';

const cx = cls.bind(s);

class ServiceClasses extends PureComponent {
  static propTypes = {
    onChangeServiceClass: PropTypes.func.isRequired,
    serviceClassesKeys: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.object)),
  };

  static defaultProps = {
    // eslint-disable-next-line react/default-props-match-prop-types
    onChangeServiceClass: NOOP,
    serviceClassesKeys: ['economy', 'premium', 'premiumEconomy', 'business', 'first'],
  };

  render() {
    const { selectedClass, onChangeServiceClass, serviceClassesKeys } = this.props;
    const activeIdx = serviceClassesKeys.indexOf(selectedClass);
    const buttons = serviceClassesKeys.map((serviceClass, idx) => {
      return (
        // eslint-disable-next-line react/no-array-index-key
        <div className={cx('wrap')} key={idx}>
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
          <div
            className={cx('button', {
              'button--isSelected': idx === activeIdx,
            })}
            data-test={serviceClass}
            onClick={onChangeServiceClass.bind(this, serviceClass)}
          >
            {' '}
            {l10n(`flight.service.${serviceClass}`)}{' '}
          </div>
        </div>
      );
    });

    return (
      <div className={cx('ServiceClasses')} data-test="service-classes">
        {buttons}
      </div>
    );
  }
}

export default ServiceClasses;
